import React from 'react';
import { NiceSignInFeatureId } from './nice-sign-in-features';

interface NiceSignInFeatureIconProps {
  featureId: NiceSignInFeatureId;
}

export function NiceSignInFeatureIcon({ featureId }: NiceSignInFeatureIconProps) {
  switch (featureId) {
    case 'softphone':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M6.5 3h3l1.5 5-2 1.2a12 12 0 0 0 5.3 5.3L15.5 13l5 1.5v3a1.5 1.5 0 0 1-1.4 1.5C9.8 19.2 4.8 14.2 4 7.9A1.5 1.5 0 0 1 5.5 6.5Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'sapDial':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M4 6.5A2.5 2.5 0 0 1 6.5 4H10v3H8v2H5v1.5A2.5 2.5 0 0 1 2.5 8 2.5 2.5 0 0 1 4 6.5Zm14 0A2.5 2.5 0 0 1 20 4h3.5v3H21v2h-2v1.5A2.5 2.5 0 0 1 16.5 8 2.5 2.5 0 0 1 18 6.5ZM8 14h8v6H8v-6Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'contacts':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M10.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 8v-1a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v1H4.5Zm11.5-7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm1.5 6v-1a4 4 0 0 0-2.3-3.6 6.5 6.5 0 0 1 2.8 5.6h-0.5Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'transfer':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="m8 7 4-4 4 4h-3v4h-2V7H8Zm8 10-4 4-4-4h3v-4h2v4h3Z" fill="currentColor" />
        </svg>
      );
    case 'acw':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M7 3h10a2 2 0 0 1 2 2v14l-7-3-7 3V5a2 2 0 0 1 2-2Zm2 6h6v2H9V9Zm0 4h4v2H9v-2Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'activityLog':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 5v5.2l4.2 2.5-.8 1.3L11 13V7h2Z"
            fill="currentColor"
          />
        </svg>
      );
    default:
      return null;
  }
}
